import Head from 'next/head'
import { Container } from 'components/ui'
import type { FC } from 'react'
import Layout, { Breadcrumb, BreadcrumbProps } from 'components/layout'
import { ProductListView } from 'modules/products/containers'
import parser from 'fazendinha/product'
import { useRouter } from 'next/router'
import AffiliateService from 'modules/affiliates/services/affiliate-service'
import { useEffect, useState } from 'react'
import AffiliateProfile from 'modules/affiliates/components/AffiliateProfile'
import Cookies from 'js-cookie'
import s from 'modules/affiliates/components/AffiliateProfile.module.css'

interface AffiliateProps {}

const AffiliatePage: FC<AffiliateProps> = () => {
  const router = useRouter()
  const { slug } = router.query as { slug: string }
  const [affiliate, setAffiliate] = useState<any>(null)
  const [products, setProducts] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    setLoading(true)
    const affiliateService = new AffiliateService()
    affiliateService.setUrl(`/afiliados/pagina/${slug}`).get().then((res) => {
      setAffiliate(res.data.afiliado)
      setProducts((res.data.produtos_favoritos || []).filter((p: any) => !!p && typeof p === 'object').map((p: any) => {
        var product = parser(p)
        product.afiliadoId = res.data.afiliado.id
        return product
      }))
      if (res.data.afiliado && res.data.afiliado.id) {
        Cookies.set('afiliadoId', res.data.afiliado.id, { expires: 5 })
      }
    }).finally(() => setLoading(false))
  }, [slug])

  const crumbs: BreadcrumbProps['crumbs'] = [{ url: '/programa-afiliados', label: 'Afiliados' }]
  if (affiliate && affiliate.nome) {
    crumbs.push({ label: affiliate.nome })
  }

  return (
    <Layout>
      <Head>
        <title>{affiliate?.titulo || 'Afiliados'}</title>
      </Head>
      <Breadcrumb crumbs={crumbs} />
      <Container>
        {loading && <div>Carregando...</div>}
        {!loading && affiliate && (
          <>
            {/* Banner e nome da página */}
            <div className={s.root}>
              {(
                <div className={s.header}>
                  <img src={affiliate.imagem_banner_url || '/assets/images/afiliados/banner-perfil-afiliado.jpg'} alt={affiliate.nome} />
                </div>
              )}
              <h1 className={s.title} style={{ marginTop: 10 }}>{affiliate.titulo}</h1>
            </div>
            {/* Produtos */}
            
            <ProductListView sellersPage isSearch={true} lastPage={1} filters={false} baseUrl={router.asPath} products={products} />
            {/* Informações do afiliado, sem banner */}
            <AffiliateProfile affiliate={affiliate} onlyInfo withHeader={false} />
          </>
        )}
        {!loading && !affiliate && <div>Afiliado não encontrado.</div>}
      </Container>
    </Layout>
  )
}

export default AffiliatePage 